import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  StyledLabel,
  StyledBoxInputSkill,
  StyledBoxModule,
  StyledOrderItemSkill,
  StyledIcon,
  StyledBoxTwoModules
} from './style';
import {
  getHobbyCategories,
  getHobbiesByCat
} from '../../../../utils/apiDataUserForm';

import DropdownInput from '../../../core/DropdownInput';
import { HOBBIES } from '../../../../constants/literals/modals';
import { Trash } from '../../../../../assets/images/index';

const HobbyItem = ({
  hobbyId,
  hobbyCatId,
  order,
  onClickDown,
  onClickUp,
  onClickDelete,
  onChangeHobbyId,
  onChangeHobbyCatId,
  className
}) => {
  const [hobbyCatList, setHobbyCatList] = useState(null);
  const [currentHobbyCat, setCurrentHobbyCat] = useState(null);
  const [hobbyList, setHobbyList] = useState(null);
  const [currentHobby, setCurrentHobby] = useState(null);

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      getHobbyCategories().then(categories => {
        setHobbyCatList(categories);
        if (hobbyCatId) {
          setCurrentHobbyCat(
            categories.filter(s => s.id === hobbyCatId)[0].name
          );

          getHobbiesByCat(hobbyCatId).then(hobbies => {
            setHobbyList(hobbies);
            if (hobbyId) {
              setCurrentHobby(hobbies.filter(s => s.id === hobbyId)[0].name);
            }
          });
        }
      });
      isInitialMount.current = false;
    } else {
      // eslint-disable-next-line no-lonely-if
      if (hobbyCatId && hobbyId) {
        setCurrentHobbyCat(
          hobbyCatList.filter(s => s.id === hobbyCatId)[0].name
        );
        getHobbiesByCat(hobbyCatId).then(hobbies => {
          setHobbyList(hobbies);
          if (hobbyId) {
            setCurrentHobby(hobbies.filter(s => s.id === hobbyId)[0].name);
          }
        });
      } else if (hobbyCatId) {
        setCurrentHobbyCat(
          hobbyCatList.filter(s => s.id === hobbyCatId)[0].name
        );
        getHobbiesByCat(hobbyCatId).then(hobbies => {
          setHobbyList(hobbies);
        });
        setCurrentHobby(null);
      } else if (hobbyId) {
        setCurrentHobby(hobbyList.filter(s => s.id === hobbyId)[0].name);
      } else {
        setCurrentHobbyCat(null);
        setHobbyList(null);
        setCurrentHobby(null);
      }
    }
  }, [hobbyCatId, hobbyId]);

  return (
    <StyledBoxModule className={className}>
      <StyledOrderItemSkill
        order={order}
        onClickDown={onClickDown}
        onClickUp={onClickUp}
      />
      <StyledBoxTwoModules>
        <StyledBoxInputSkill
          className={`${currentHobbyCat ? 'skill-input' : ''}`}
        >
          <StyledLabel>{HOBBIES.CATEGORY}</StyledLabel>
          {hobbyCatList && (
            <DropdownInput
              className="form-dropdown"
              list={hobbyCatList}
              label={currentHobbyCat || 'Seleccionar Categoría Hobby'}
              onSelect={e => {
                onChangeHobbyCatId(e);
              }}
            />
          )}
        </StyledBoxInputSkill>
        <StyledBoxInputSkill className={`${currentHobby ? 'skill-input' : ''}`}>
          <StyledLabel>{HOBBIES.HOBBY}</StyledLabel>
          {hobbyList && (
            <DropdownInput
              className="form-dropdown"
              list={hobbyList}
              label={currentHobby || 'Seleccionar Hobby'}
              onSelect={e => {
                onChangeHobbyId(e);
              }}
            />
          )}
        </StyledBoxInputSkill>
      </StyledBoxTwoModules>
      <StyledIcon
        className="icon-trash"
        svg={Trash}
        hover
        onClick={onClickDelete}
      />
    </StyledBoxModule>
  );
};

HobbyItem.propTypes = {
  hobbyCatId: PropTypes.number,
  hobbyId: PropTypes.number,
  order: PropTypes.number,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  onChangeHobbyId: PropTypes.func,
  onChangeHobbyCatId: PropTypes.func,
  onClickDelete: PropTypes.func,
  className: PropTypes.string
};

HobbyItem.defaultProps = {
  order: 0,
  className: ''
};

export default HobbyItem;
